import { TranslationKey } from '@/contexts/translations';
import styles from './form-button-row.module.css';
import { Button, ButtonLinkProps, RegularButtonProps } from '@/components/button';
import { useTranslation } from '@/contexts/i18n-context';
import clsx from 'clsx';

type FormButtonBaseProps = {
  buttonTextKey: TranslationKey;
  secondaryButton?: React.ReactNode;
} & ({ nextStep?: string; description?: never } | { description?: string; nextStep?: never });

export type FormButtonRowProps =
  | (Omit<RegularButtonProps, 'children'> & FormButtonBaseProps)
  | (Omit<ButtonLinkProps, 'children'> & FormButtonBaseProps);

export function FormButtonRow({
  nextStep,
  description,
  buttonTextKey,
  secondaryButton,
  className,
  ...restProps
}: FormButtonRowProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.formButtonRow}>
      {(nextStep || description) && (
        <span className={styles.nextStep}>
          {nextStep && <span>{`${t('common.next')}: `}</span>}
          <span className={clsx(styles.nextStepText, 'semibold')}>{nextStep ?? description}</span>
        </span>
      )}
      {secondaryButton}
      <Button className={className} color="accent" {...restProps}>
        {t(buttonTextKey)}
      </Button>
    </div>
  );
}
